export const MessagingAnalyticsFeatureFlags = {
  demoData: 'messaging-analytics-demo-data',
  featureEnabled: 'sms-reporting-enabled',
} as const;
